<template>
    <div class="conut-box">
        <button class="minus" @click="sub"> - </button>

        <input type="number" :value="value" class="inp">

        <button class="add" @click="add"> + </button>

    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 1
        }
    },

    methods: {
        sub() {
            if(this.value<1){
                return
            }
            this.$emit('input', this.value - 1)
        },
        add() {
            this.$emit('input', this.value + 1)
        }
    }

}
</script>

<style scoped>
.conut-box {
    width: 100px;
    height: 30px;
    display: flex;
    background-color: #ffffff;
}

.inp {
    width: 40px;
    height: 30px;
    margin: 0 5px 0 5px;
    outline: none;
    border: none;
    background-color: #ececec;
    text-align: center;
}

.minus {
    width: 40px;
    height: 30px;
    outline: none;
    border: none;
}

.add {
    width: 40px;
    height: 30px;
    outline: none;
    border: none;
}
</style>